import "./slidebar.css";
import { useState } from "react";
import ButtonAdmin from "../CustomComponent/ButtonAdmin";
import { useEffect } from "react";
import { useGlobalContext } from "../../../Context/Context";
import Button from "../../Custom/Button/Button";
import ArrowImg from "./NextLanguage.png";
import GearImg from "../../picture/16.png";
import useIsOpening from "../../../Context/hooks/useIsOpening";

function Slidebar({
  currentTab,
  isCardActive,
  setCurrentTab,
  setActiveIcons,
  activeIcons,
  slideButton,
  speakerButton,
  languageButton,
  setSlideButton,
  setSpeakerButton,
  setLanguageButton,
  checkIfNoOneActive,
  selectedCompany,
}) {
  const { cancelIndex, setActiveIconsMiddleAdmin, activeIconsMiddleAdmin } =
    useGlobalContext();

  const { isOpening } = useIsOpening();

  const [arrowExpanded, setArrowExpanded] = useState(isOpening ? true : false);

  const [clickSpeaker, setClickSpeaker] = useState({
    index: 0,
    value: false,
  });

  const [clickFolder, setClickFolder] = useState({
    index: 0,
    value: false,
  });

  const setPriorityActive = (position, button, setButton) => {
    const newSlideButton = button.map((item, index) => {
      if (index === position) {
        let maximum = 0;
        button.map((item) => {
          if (item.active > maximum) maximum = item.active;
          return maximum;
        });
        maximum = maximum + 1;
        return { ...item, active: maximum };
      }
      return item;
    });
    setButton(newSlideButton);
  };

  const setPriorityNotActive = (position, button, setButton) => {
    let priority;
    let newSlideButton = button.map((item, index) => {
      if (index === position) {
        priority = item.active;
        return { ...item, active: 0 };
      }
      return item;
    });
    let newPrioritySlideButton = newSlideButton.map((item) => {
      if (item.active > priority) {
        return { ...item, active: item.active - 1 };
      }
      return item;
    });
    setButton(newPrioritySlideButton);
  };

  const handleActiveAdminButton = (position) => {
    if (!isCardActive) return;
    if (!selectedCompany) return;

    if (position === 2) {
      setClickSpeaker({
        index: 0,
        value: !clickSpeaker.value,
      });
      if (!checkIfNoOneActiveSpeaker()) {
        setPriorityActive(position, slideButton, setSlideButton);
      }
    } else if (position === 5) {
      setClickFolder({
        index: 0,
        value: !clickFolder.value,
      });
    }

    setPriorityActive(position, slideButton, setSlideButton);
  };

  const handleActiveSpeakerButton = (position) => {
    let newSpeakerButton = speakerButton;
    if (checkIfNoOneActiveSpeaker()) {
      let array = [0, 1, 2];
      array.forEach((_, index) => {
        if (index !== position) {
          newSpeakerButton[index].active = 0;
        } else {
          newSpeakerButton[index].active = 1;
        }
      });
      setSpeakerButton(newSpeakerButton);
    } else {
      setPriorityActive(position, speakerButton, setSpeakerButton);
    }
    handleSetActiveIcons();
    setCurrentTab(speakerButton[position].name);
    setClickSpeaker({ ...clickSpeaker, value: false });
  };

  const handleNotActiveAdminButton = (position) => {
    if (!selectedCompany) return;
    if (position === 5) {
      setClickFolder({
        index: "",
        value: !clickFolder.value,
      });
      if (clickFolder.value) {
        setPriorityNotActive(position, slideButton, setSlideButton);
        const newActiveIconsMiddle = activeIconsMiddleAdmin.filter(
          (icon) => icon.name !== currentTab,
        );
        setActiveIconsMiddleAdmin(newActiveIconsMiddle);
      }
      return;
    }
    if (position === 2) {
      setClickSpeaker({
        index: "",
        value: !clickSpeaker.value,
      });
      if (clickSpeaker.value) {
        setPriorityNotActive(position, slideButton, setSlideButton);
        let current = speakerButton.indexOf(
          speakerButton.find((btn) => btn.active > 0),
        );
        const newActiveIconsMiddle = activeIconsMiddleAdmin.filter(
          (icon) => icon.name !== currentTab,
        );
        setActiveIconsMiddleAdmin(newActiveIconsMiddle);
        setPriorityNotActive(current, speakerButton, setSpeakerButton);
      }
      return;
    }
    setPriorityNotActive(position, slideButton, setSlideButton);
  };

  const checkIfNoOneActiveSpeaker = () => {
    return speakerButton.find((item) => item.active > 0) !== undefined;
  };

  const handleSetActiveIcons = () => {
    let activeButtons = slideButton.filter((button) => button.active !== 0);
    let speakerBtn = speakerButton.find((button) => button.active !== 0);

    let newSortedActiveButtons = activeButtons.map((btn) => {
      if (btn.name === "SPEAKER") {
        if (speakerBtn !== undefined)
          return { ...speakerBtn, active: btn.active };
      }
      return btn;
    });

    let sortedActiveButtons = newSortedActiveButtons
      .filter((btn) => btn.name !== "SPEAKER")
      .sort((a, b) => a.active - b.active);

    setActiveIcons(sortedActiveButtons);

    let wraperProfile = document.querySelector(
      ".wraper-user-location-choose-object",
    );
    if (wraperProfile === null) {
      wraperProfile = document.querySelector(".wraper-user-location");
    }
    if (wraperProfile) {
      const buttonCompanyDim = document.querySelector(".button-picture");
      if (buttonCompanyDim)
        wraperProfile.style.height = `${buttonCompanyDim.getBoundingClientRect().height}px`;
    }
  };

  const handleActivation = (index) => {
    if (index === 2) return checkIfNoOneActiveSpeaker();
    return selectedCompany ? false : true;
  };

  const handleCorrect = () => {
    let priority = 0;
    let position = 0;
    slideButton.forEach((item, i) => {
      if (item.active > priority) {
        priority = item.active;
        position = i;
      }
    });
    if (position !== 2) setCurrentTab(slideButton[position].name);
  };

  useEffect(() => {
    if (!checkIfNoOneActive()) {
      setCurrentTab(null);
      setClickSpeaker({ index: 0, value: false });
    } else {
      handleCorrect();
    }
    handleSetActiveIcons();
  }, [speakerButton, slideButton]);

  useEffect(() => {
    if (cancelIndex !== null) {
      handleNotActiveAdminButton(cancelIndex);
    }
  }, [cancelIndex]);

  useEffect(() => {
    if (
      activeIcons.length === 0 &&
      slideButton.find((btn) => btn.active !== 0) === undefined
    ) {
      setClickFolder({ index: 0, value: false });
      setClickSpeaker({ index: 0, value: false });
    }
  }, [activeIcons]);

  useEffect(() => {
    let container;
    if (clickSpeaker.value) container = document.querySelector(".speaker");
    else container = document.querySelector(".folder");
    if (container) {
      const buttonPicture = document
        .querySelector(".button-picture")
        .getBoundingClientRect();
      container.style.bottom = `${buttonPicture.height}px`;
    }
  }, [clickSpeaker, clickFolder]);

  const visibleButtons = slideButton.filter(
    (item) => item.name !== "GALERIJA" && item.name !== "LANGUAGE",
  );

  return (
    <div
      className="slide-bar"
      style={{
        pointerEvents: isOpening ? "none" : "auto",
        userSelect: "none",
        WebkitUserSelect: "none",
      }}
    >
      {/* 1. Taster za podešavanja - ikonica zupčanika */}
      <div className="button-settings">
        <Button activation={true}>
          <img
            src={GearImg}
            alt="Podesavanja"
            style={{ width: "80%", display: "block" }}
          />
        </Button>
      </div>

      {/* 2. Strelica - rotira se kad je otvorena */}
      <div
        className="button-arrow"
        onClick={() => setArrowExpanded(!arrowExpanded)}
      >
        <Button activation={true}>
          <img
            src={ArrowImg}
            alt="Prosiri"
            style={{
              width: "80%",
              display: "block",
              transition: "transform 0.25s ease",
              transform: arrowExpanded ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </Button>
      </div>

      {/* 3. Ostali tasteri - vidljivi samo kad je strelica otvorena */}
      {arrowExpanded &&
        visibleButtons.map((item) => {
          const originalIndex = slideButton.indexOf(item);
          return (
            <ButtonAdmin
              key={originalIndex}
              data={item}
              slideButton={slideButton}
              position={originalIndex}
              handleActive={handleActiveAdminButton}
              handleNotActive={handleNotActiveAdminButton}
              selectedCompany={selectedCompany}
              handleActivation={handleActivation}
            />
          );
        })}

      {clickSpeaker.value && (
        <div className="speaker">
          {speakerButton.map((item, index) => (
            <div
              key={index}
              className="button-slidebar-speaker"
              onClick={() => handleActiveSpeakerButton(index)}
            >
              <Button
                active={item.active}
                activation={selectedCompany ? false : true}
              >
                {item.name}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Slidebar;
